module.exports = __webpack_public_path__ + "static/img/no-data.3e4c6f06.png";